export const Name = 'jdp-ab-test-new-components';
